export enum ResendInvoiceFormActiveState {
  NO_PANEL,
  NAME_ADDRESS,
  EMAIL_ADDRESS,
  FAX,
}
